import React from 'react';
import { KICK_AVENUE_SOURCE, SHOPEE_SOURCE, TIKTOK_SOURCE } from '../../constants/kickavenue';
import { ReturnsContainer, guardReturns } from './ReturnsContainer';

const DEFAULT_ROLES = ['supervisor', 'sale_supervisor'];
const COURIER_ROLES = ['supervisor', 'sale_supervisor', 'courier'];

const page = (config) => guardReturns(
  (props) => <ReturnsContainer {...config} {...props} />,
  config.queue === 'delivering' ? COURIER_ROLES : DEFAULT_ROLES
);

export const AllReturns = page({
  title: 'All Returns',
  description: 'Every return.',
  type: 'return_all',
  queue: 'all',
  analyticsPageName: 'returns_all',
});

export const OutstandingReturns = page({
  title: 'Outstanding Returns',
  description: 'Confirm receipt of goods returned by the buyer.',
  type: 'return_outstanding',
  queue: 'outstanding',
  analyticsPageName: 'returns_outstanding',
});

export const QcReturns = page({
  title: 'Quality Control',
  description: 'Pass moves the return to relisting. Fail moves it to follow up.',
  type: 'return_qc',
  queue: 'qc',
  analyticsPageName: 'returns_qc',
});

export const RelistingReturns = page({
  title: 'Need Relisting',
  description: 'Relist the goods onto a Kick Avenue account. A successful relist opens the refund queue.',
  type: 'return_relisting',
  queue: 'relisting',
  analyticsPageName: 'returns_relisting',
});

export const RefundReturns = page({
  title: 'Need Return Refund',
  description: 'Record the refund after relisting. The money movement stays on the existing disbursement screens.',
  type: 'return_refund',
  queue: 'refund',
  analyticsPageName: 'returns_refund',
});

export const ProcessedReturns = page({
  title: 'Processed Return',
  description: 'Final queue for returns that passed Quality Control.',
  type: 'return_processed',
  queue: 'processed',
  analyticsPageName: 'returns_processed',
});

export const FollowUpReturns = page({
  title: 'Follow Up',
  description: 'Quality Control failed. Save the ship-back courier and airway bill.',
  type: 'return_follow_up',
  queue: 'follow_up',
  analyticsPageName: 'returns_follow_up',
});

export const AllPreDeliveringReturns = page({
  title: 'Return Pre-Delivering',
  description: 'Follow-up is done and the goods are going back to the buyer.',
  type: 'return_pre_delivering',
  queue: 'pre_delivering',
  analyticsPageName: 'returns_pre_delivering',
});

export const KickAvenuePreDeliveringReturns = page({
  title: 'Kick Avenue Return Pre-Delivering',
  description: 'Kick Avenue returns waiting to go back to the buyer, including Store sales.',
  type: 'return_pre_delivering',
  createdSource: KICK_AVENUE_SOURCE,
  queue: 'pre_delivering',
  analyticsPageName: 'returns_kick_avenue_pre_delivering',
});

export const TiktokPreDeliveringReturns = page({
  title: 'TikTok Return Pre-Delivering',
  description: 'TikTok returns waiting to go back to the buyer.',
  type: 'return_pre_delivering',
  createdSource: TIKTOK_SOURCE,
  queue: 'pre_delivering',
  analyticsPageName: 'returns_tiktok_pre_delivering',
});

export const ShopeePreDeliveringReturns = page({
  title: 'Shopee Return Pre-Delivering',
  description: 'Shopee returns waiting to go back to the buyer.',
  type: 'return_pre_delivering',
  createdSource: SHOPEE_SOURCE,
  queue: 'pre_delivering',
  analyticsPageName: 'returns_shopee_pre_delivering',
});

export const AllDeliveringReturns = page({
  title: 'Return Delivering',
  description: 'Returns in transit back to the buyer.',
  type: 'return_delivering',
  queue: 'delivering',
  analyticsPageName: 'returns_delivering',
});

export const JntDeliveringReturns = page({
  title: 'JNT Return Delivering',
  description: 'JNT returns in transit back to the buyer.',
  type: 'return_delivering',
  courier: 'jnt',
  queue: 'delivering',
  analyticsPageName: 'returns_jnt_delivering',
});

export const TikiDeliveringReturns = page({
  title: 'TIKI Return Delivering',
  description: 'TIKI returns in transit back to the buyer.',
  type: 'return_delivering',
  courier: 'tiki',
  queue: 'delivering',
  analyticsPageName: 'returns_tiki_delivering',
});

export const SpxDeliveringReturns = page({
  title: 'SPX Return Delivering',
  description: 'SPX returns in transit back to the buyer.',
  type: 'return_delivering',
  courier: 'spx',
  queue: 'delivering',
  analyticsPageName: 'returns_spx_delivering',
});

export const InstantDeliveringReturns = page({
  title: 'Gosend/Grab Return Delivering',
  description: 'Gosend and Grab returns in transit back to the buyer.',
  type: 'return_delivering',
  courier: 'instant_courier',
  queue: 'delivering',
  analyticsPageName: 'returns_instant_delivering',
});

export const WarehouseDeliveringReturns = page({
  title: 'Warehouse Return Delivering',
  description: 'Warehouse returns in transit back to the buyer.',
  type: 'return_delivering',
  courier: 'warehouse',
  queue: 'delivering',
  analyticsPageName: 'returns_warehouse_delivering',
});

export const OtherDeliveringReturns = page({
  title: 'Other Return Delivering',
  description: 'Other-courier returns in transit back to the buyer.',
  type: 'return_delivering',
  courier: 'others',
  queue: 'delivering',
  analyticsPageName: 'returns_other_delivering',
});

export const RejectedReturns = page({
  title: 'Rejected Returns',
  description: 'Final queue for the fail path.',
  type: 'return_rejected',
  queue: 'rejected',
  analyticsPageName: 'returns_rejected',
});
